import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import DashboardLogin from "../pages/dashboard/login/page";
import Dashboard from "../pages/dashboard/page";
import AnalyticsAPI from "../pages/api/analytics/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/dashboard/login",
    element: <DashboardLogin />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/api/analytics",
    element: <AnalyticsAPI />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;